export const i18nDefaults = {
  'enum.none': 'None',
  'enum.placeholder': 'Select an option',
  'oneofenum.placeholder': 'Select one or more options',
  'stepper.previous': 'Previous',
  'stepper.next': 'Next',
};